/**
 * Local Delivery Cart V2 bootstrap.
 * Full orchestration lives in wf-ld-cart-init.js and helper modules.
 */
(function () {
  'use strict';

  var runtime = window.WF_LD_RUNTIME || {};
  if ((runtime.cartOrchestrator || 'v1') !== 'v2') return;

  var deps = {
    API: window.WF_LD_API,
    DATE: window.WF_LD_DATE_UTILS,
    POSTAL: window.WF_LD_POSTAL_UTILS,
    SLOT: window.WF_LD_SLOT_UTILS,
    STORAGE: window.WF_LD_STORAGE,
    EXPRESS: window.WF_LD_EXPRESS_CART,
    PICKER: window.WF_LD_DATE_PICKER,
    ADDRESS_AC: window.WF_LD_ADDRESS_AC,
    DOMAIN: window.WF_LD_CART_DOMAIN,
    TIMESLOTS: window.WF_LD_CART_TIMESLOTS,
    CHECKOUT: window.WF_LD_CART_CHECKOUT,
    VALIDATION: window.WF_LD_CART_VALIDATION,
    CHECKOUT_FLOW: window.WF_LD_CART_CHECKOUT_FLOW,
    UI: window.WF_LD_CART_UI,
  };

  var INIT = window.WF_LD_CART_INIT;
  if (!INIT || typeof INIT.createInitController !== 'function') {
    console.warn('[wf-ld-v2] Missing WF_LD_CART_INIT');
    return;
  }

  var missing = Object.keys(deps).filter(function (k) { return !deps[k]; });
  if (missing.length > 0) {
    console.warn('[wf-ld-v2] Missing modules:', missing.join(', '));
    return;
  }

  var controller = INIT.createInitController({
    deps: deps,
    runtime: runtime,
  });

  if (!controller || typeof controller.init !== 'function') {
    console.warn('[wf-ld-v2] Invalid init controller');
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      controller.init();
    });
  } else {
    controller.init();
  }

  /**
   * BUG-025 follow-up: the cart silent-refresh in `wf-cart-line-messages.js`
   * (fired after Save message AND after the theme's quantity stepper) replaces
   * `.cart__item-list` wholesale. On WF, `#wf-ld-custom` lives INSIDE that
   * container, so the live, initialised delivery panel is yanked out and
   * replaced with a freshly-rendered "Loading delivery options..." shell.
   * Since `init()` only runs at DOMContentLoaded, the panel would stay stuck.
   *
   * `swapCartSection` already dispatches `wf:cart:refreshed` after every
   * successful swap. We dispose stale mixed-cart observers (they hold refs
   * to the now-detached `.cart__item-list`) then re-run `init()` to bootstrap
   * the freshly-rendered panel. Re-entry is safe — `initForm` bumps
   * `formInitGeneration` and disposes the prior session before re-binding.
   *
   * Zombie checkout block prune: `wf-ld-cart-init.js` (~line 1672) hoists
   * `.cart__price-breakdown` (the wrapper around `#wf-ld-checkout`) OUT of
   * `<form id="cart_form">` and re-attaches it as a direct child of
   * `<div class="cart__form">` so the checkout button sits below the cart.
   * On every silent refresh the inner `.cart__item-list` is replaced with
   * fresh markup that re-includes a NEW `.cart__price-breakdown` inside the
   * form — but the PREVIOUSLY hoisted wrap still sits outside the form
   * untouched (it's a sibling of the form, not inside the swapped container).
   * Without pruning, every save adds one more zombie checkout block stacked
   * below the cart. Strip them before re-init so the next hoist produces
   * exactly one.
   */
  function pruneHoistedCheckoutBlocks() {
    if (typeof document === 'undefined' || typeof document.querySelectorAll !== 'function') return;
    var zombies = document.querySelectorAll('div.cart__form > .cart__price-breakdown');
    for (var i = 0; i < zombies.length; i++) {
      var node = zombies[i];
      if (node && node.parentNode) node.parentNode.removeChild(node);
    }
  }

  if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
    document.addEventListener('wf:cart:refreshed', function () {
      try {
        pruneHoistedCheckoutBlocks();
        if (typeof controller.disposeMixedCartObservers === 'function') {
          controller.disposeMixedCartObservers();
        }
        controller.init();
      } catch (err) {
        console.warn('[wf-ld-v2] re-init after wf:cart:refreshed failed', err);
      }
    });
  }
})();
